import React from "react";
import { WorkflowTroubleshoot } from "us.collection/components";
import { withRouter } from "us.common/wIthRouter";

const Cnt_Troubleshoot: React.FC = () => {
  return <WorkflowTroubleshoot />;
};

export default withRouter(Cnt_Troubleshoot);
